import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/view/index'], resolve),
      redirect: '/userList',
      children: [
        // 新数据
        
        {
          path: '/userList',
          name: 'userList',
          component: resolve => require(['@/view/user/userList'], resolve),
          children: [
              {
                  path: 'details',
                  name: 'userDetails',
                  component: resolve => require(['@/view/user/userDetails'], resolve),
                  meta: {
                      title: '门店详情',
                      primary:true,
                  },
              },
          ]
        },
        {
          path: '/orderList',
          name: 'orderList',
          component: resolve => require(['@/view/showroom/orderList'], resolve),
          children: [
              {
                  path: 'details',
                  name: 'orderDetails',
                  component: resolve => require(['@/view/showroom/orderDetails'], resolve),
                  meta: {
                      title: '订单详情',
                      primary:true
                  },
              },
          ]
        },
        {
          path: '/auditList',
          name: 'auditList',
          component: resolve => require(['@/view/showroom/auditList'], resolve),
          children: [
              {
                  path: 'details',
                  name: 'auditDetails',
                  component: resolve => require(['@/view/showroom/auditDetails'], resolve),
                  meta: {
                      title: '理赔订单详情',
                      primary:true
                  },
              },
          ]
        },
        {
          path: '/guarantee',
          name: 'guarantee',
          component: resolve => require(['@/view/showroom/guarantee'], resolve),
          children: [
            {
                path: 'details',
                name: 'guaranteeDetails',
                component: resolve => require(['@/view/showroom/guaranteeDetails'], resolve),
                meta: {
                    title: '三包理赔审核详情页',
                    primary:true
                },
            },
          ]
        },
        {
          path: '/pcBanner',
          name: 'pcBanner',
          component: resolve => require(['@/view/setting/pcBanner'], resolve),
        },
        {
          path: '/systemUser',
          name: 'systemUser',
          component: resolve => require(['@/view/system/systemUser'], resolve),
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/login/login'], resolve),
    },
    {
      path: '*',
      component: resolve => require(['@/view/404'], resolve),
    }
    
    


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js